import React from 'react'

const usePermission = (permissionName: PermissionName) => {
  const [permissionState, setPermissionState] =
    React.useState<PermissionState | null>(null)

  React.useEffect(() => {
    const req = async () => {
      // Assume granted if not supported
      if (!navigator.permissions) {
        setPermissionState('granted')
        return
      }

      const result = await navigator.permissions.query({ name: permissionName })

      setPermissionState(result.state)

      result.onchange = () => {
        setPermissionState(result.state)
      }
    }

    req()
  }, [permissionName])

  return permissionState
}

export default usePermission
